import { useEffect, useState } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { useParams } from "react-router-dom";
import { AccountRoutes } from "../AccountRoutes";
import { NSLoading, NSRow } from "namirasoft-site-react";

interface SessionViewDecidePageProps extends NSARouterMakerResult, AccountRouterProps
{ }

interface SessionViewDecidePageState 
{
	session: boolean | null;
	service_session: boolean | null;
}

export default function SessionViewDecidePage(props: SessionViewDecidePageProps) 
{
	let { id } = useParams();

	let [state, setState] = useState<SessionViewDecidePageState>({ session: null, service_session: null });

	useEffect(() =>
	{
		if (id)
		{
			props.account.server.session.Get(id, { onError: () => { } }).then(() =>
			{
				if (id)
					props.url.redirect(AccountRoutes.SessionView(id), {});
			}).catch(() =>
			{
				setState(prev => { return { ...prev, session: false } });

				if (id)
				{
					props.account.server.service_session.Get(id, { onError: () => { } }).then(() =>
					{
						if (id)
							props.url.redirect(AccountRoutes.ServiceSessionView(id), {});
					}).catch(() =>
					{
						setState(prev => { return { ...prev, service_session: false } });
					});
				}
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps 
	}, []);

	let not_found = state.session === false && state.service_session === false;
	return (
		<AccountLayout {...props}
			action={{ title: not_found ? 'Not Found' : 'Redirecting', description: '', menus: {} }}
		>
			<NSRow>
				{
					!not_found ? (
						<NSLoading />
					) : (<></>)
				}
			</NSRow>
		</AccountLayout >
	);
};